module.exports = "<p>bar-chart-widget works!</p>\n"